import { Card } from '../../ui/Card'
import { Button } from '../../ui/Button'
import { EmptyState } from '../../ui/Feedback'
import { PageHeader } from '../shared/PageHeader'

export function ActivityPage({ onNavigate }: { onNavigate?: ((path: string) => void) | undefined }) {
  return <><PageHeader eyebrow="Advanced" title="Activity" description="Chain decisions and host changes, explained in renter language." /><Card><EmptyState title="No activity to show yet" body="When your first instance is created, offers, host changes, and recovery decisions will appear here." action={<Button onClick={() => onNavigate?.('/app/rent')}>Browse hosts</Button>} /></Card></>
}
